export default __webpack_public_path__ + "static/media/anagrafica_diario.eabaf5aa.less";